import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '@app/components/pipes/pipes.module';
import { MaterialPublicModule } from '../angular-material/material-public.module';

import { VideoPlayerDialogComponent } from './video-player-dialog/video-player-dialog.component';
import { TimeoutDialogComponent } from './timeout-dialog/timeout-dialog.component';
import { ConfirmActionDialogComponent } from './confirm-action-dialog/confirm-action-dialog.component';
import { ImagesViewerDialogComponent } from './images-viewer-dialog/images-viewer-dialog.component';

@NgModule({
    declarations: [
        VideoPlayerDialogComponent,
        TimeoutDialogComponent,
        ConfirmActionDialogComponent,
        ImagesViewerDialogComponent
    ],
    exports: [
        VideoPlayerDialogComponent,
        TimeoutDialogComponent,
        ConfirmActionDialogComponent,
        ImagesViewerDialogComponent
    ],
    imports: [
        MaterialPublicModule,
        FormsModule,
        ReactiveFormsModule,
        PipesModule
    ]
})
export class DialogsModule { }
